import { useState } from 'react';

/**
 * Custom hook for managing Safety Message Plan state (ICS 208)
 */
const useSafetyMessagePlan = () => {
  const [safetyMessages, setSafetyMessages] = useState([]);
  const [currentSafetyMessage, setCurrentSafetyMessage] = useState({
    safetyMessage: '',
    expandedMessage: '',
    safetyPlan: '',
    sketchData: null
  });
  const [editingSafetyMessage, setEditingSafetyMessage] = useState(null);

  const getDefaultSafetyMessage = () => ({
    safetyMessage: '',
    expandedMessage: '',
    safetyPlan: '',
    sketchData: null
  });

  const addSafetyMessage = () => {
    if (!currentSafetyMessage.safetyMessage.trim()) {
      alert('Please enter a safety message');
      return;
    }
    
    if (editingSafetyMessage) {
      setSafetyMessages(prev => prev.map(msg => 
        msg.id === editingSafetyMessage.id 
          ? { ...currentSafetyMessage, id: msg.id, timestamp: msg.timestamp, updatedAt: new Date().toISOString() }
          : msg
      ));
      setEditingSafetyMessage(null);
    } else {
      const newMessage = {
        ...currentSafetyMessage,
        id: Date.now().toString(),
        timestamp: new Date().toISOString()
      };
      setSafetyMessages(prev => [...prev, newMessage]);
    }
    
    setCurrentSafetyMessage(getDefaultSafetyMessage());
  };
  
  const editSafetyMessage = (message) => {
    setCurrentSafetyMessage({
      safetyMessage: message.safetyMessage || '',
      expandedMessage: message.expandedMessage || '',
      safetyPlan: message.safetyPlan || '',
      sketchData: message.sketchData || null
    });
    setEditingSafetyMessage(message);
  };
  
  const cancelEditSafetyMessage = () => {
    setCurrentSafetyMessage(getDefaultSafetyMessage());
    setEditingSafetyMessage(null);
  };
  
  const deleteSafetyMessage = (messageId) => {
    if (window.confirm('Are you sure you want to delete this safety message?')) {
      setSafetyMessages(prev => prev.filter(msg => msg.id !== messageId));
    }
  };

  return {
    // State
    safetyMessages,
    setSafetyMessages,
    currentSafetyMessage,
    setCurrentSafetyMessage,
    editingSafetyMessage,
    setEditingSafetyMessage,
    // Functions
    addSafetyMessage,
    editSafetyMessage,
    cancelEditSafetyMessage,
    deleteSafetyMessage,
    getDefaultSafetyMessage
  };
};

export default useSafetyMessagePlan;
